export const doesObjectContainKey = (obj: Record<string, boolean> | null, key: string) => {
    return (
        obj &&
        ((key in obj && obj[key]) || Object.keys(obj).some((objKey) => objKey.trim().includes(key) && obj[objKey]))
    );
};
